import script from "./ErrorDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ErrorDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ErrorDialog.vue?vue&type=style&index=0&id=3f067772&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f067772"]])

export default __exports__